const AdvertisementSvg = ({
  height = 20,
  width = 20,
  viewBox = '0 0 23 23',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox}>
      <g transform="translate(0.5, 0)">
        <path
          d="M15.7578 1.61621L14.1416 2.82812H21.2129C21.7706 2.82833 22.2227 3.28113 22.2227 3.83887V17.9805C22.2225 18.5381 21.7705 18.99 21.2129 18.9902H15.6572L15.6484 19.1885C15.5627 20.1628 14.8528 20.8728 14.1123 21.2959C13.2939 21.7634 12.2307 22.0205 11.1113 22.0205C9.9919 22.0205 8.92869 21.7635 8.11035 21.2959C7.36991 20.8728 6.66097 20.1628 6.5752 19.1885L6.56641 18.9902H1.01074C0.453009 18.9902 0.000203638 18.5382 0 17.9805V3.83887C0 3.281 0.452884 2.82812 1.01074 2.82812H8.08105L6.46484 1.61621L7.67676 0L11.1113 2.57617L14.5459 0L15.7578 1.61621ZM8.58594 18.9902L8.59961 19.0537C8.63301 19.1488 8.74622 19.3322 9.11328 19.542C9.57437 19.8054 10.2787 20 11.1113 20C11.9444 20 12.6492 19.8055 13.1104 19.542C13.6 19.2622 13.6367 19.0293 13.6367 18.9902H8.58594ZM2.02051 16.9697H20.2021V4.84863H2.02051V16.9697ZM13.6367 6.86914C15.3104 6.86914 16.667 8.2258 16.667 9.89941V11.9189C16.667 13.5926 15.3104 14.9502 13.6367 14.9502H12.627C12.0691 14.9502 11.6162 14.4973 11.6162 13.9395V7.87891C11.6162 7.32104 12.0691 6.86914 12.627 6.86914H13.6367ZM8.08105 6.86914C9.4757 6.86914 10.6064 7.99985 10.6064 9.39453V13.9395H8.58594V11.9189H7.57617V13.9395H5.55566V9.39453C5.55566 7.9999 6.68647 6.86922 8.08105 6.86914ZM13.6367 12.9297C14.1946 12.9297 14.6465 12.4768 14.6465 11.9189V9.89941C14.6465 9.34153 14.1946 8.88867 13.6367 8.88867V12.9297ZM8.08105 8.88867C7.80219 8.88875 7.57617 9.11569 7.57617 9.39453V9.89941H8.58594V9.39453C8.58594 9.11564 8.35998 8.88867 8.08105 8.88867Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default AdvertisementSvg;
